const firebaseConfig = {
  apiKey: "AIzaSyAq8znu8FZddk1XLUPE3Qej7R_ZA3jA23Q",
  authDomain: "management-system-bec22.firebaseapp.com",
  projectId: "management-system-bec22",
  storageBucket: "management-system-bec22.appspot.com",
  messagingSenderId: "671405104509",
  appId: "1:671405104509:web:e534648d717d1614d74014"
   };

export default firebaseConfig;